import api from "./api";

export default {
  getAll: () => api.get("/materiais"),
  getById: (id) =>
    api.get(`/materiais/${id}`, { headers: { "Cache-Control": "no-cache" } }),
  create: (data) => api.post("/materiais", { material: data }),
  update: (id, data) => api.put(`/materiais/${id}`, { material: data }),
  destroy: (id) => api.delete(`/materiais/${id}`),
  entradaEstoque: (id, quantidade) =>
    api.patch(`/materiais/${id}/entrada_estoque`, { quantidade }),
  getCores: () => api.get("/cores"),
};
